
import { defineComponent } from "vue";
import { IJourneysModel } from "@/interfaces/modules/configuration/IJourneysModel";
import JourneysService from "@/api/Configuration/JourneysService";
import store from "@/store";

export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IJourneysModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "Description",
            label: "Descripción",
            sortable: true,
          },
          {
            key: "StartFrom",
            label: "Hora inicial",
            sortable: true,
          },
          {
            key: "StartTo",
            label: "Hora final",
            sortable: true,
          },
          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },

          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
            (item: any) =>
              item.Name.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              ) ||
              item.Description.toLowerCase().includes(
                this.table.filters.search.toLowerCase()
              )
          )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await JourneysService.GetJourneys();
      this.table.loading = false;
    },
    async edit(data: IJourneysModel) {
      this.form.record = await JourneysService.GetJourneysById(data);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as IJourneysModel;
      this.form.dialog = true;
    },

    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await JourneysService.PostJourney(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
